import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Icon column template
 */
export const IconTemplate: React.FC<{ iconEmoji: string }> = ({ iconEmoji }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 0.5 }}>
    <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
      {iconEmoji}
    </Typography>
  </Box>
);

export default IconTemplate;
